import { render, staticRenderFns } from "./AdminLicensesList.vue?vue&type=template&id=3bc316c9&scoped=true"
import script from "./AdminLicensesList.vue?vue&type=script&lang=ts"
export * from "./AdminLicensesList.vue?vue&type=script&lang=ts"
import style0 from "./AdminLicensesList.vue?vue&type=style&index=0&id=3bc316c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc316c9",
  null
  
)

export default component.exports